import "./Offer.css";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from 'react-bootstrap/Col';
import Accordion from "react-bootstrap/Accordion";
import OfferImg1 from "../assets/Yoga_Sand_Stone.png";
import OfferImg2 from "../assets/Yoga_Matte.png";
import OfferImg3 from "../assets/YogaNatur.jpeg";
import OfferImg4 from "../assets/freepik_yoga_floor.jpg";
import OfferImg5 from "../assets/freepik-frau-rumpfbeugehaltung-steht.jpeg";
import OfferImg6 from "../assets/MatteGerollt.jpeg";
import React, {useState} from "react";
import {Route, Routes} from "react-router-dom";
import Yogakurse from "./OfferItems/Yogakurse";
import Privatstunden from "./OfferItems/Privatstunden.jsx";
import Firmenyoga from "./OfferItems/Firmenyoga.jsx";
import YogaNatur from "./OfferItems/YogaNatur.jsx";
import Retreats from "./OfferItems/Retreats.jsx";
import Landsberg from "./OfferItems/Landsberg";
import {LinkContainer} from "react-router-bootstrap";
import Button from "react-bootstrap/Button";
import offerDescription from "./OfferDescription.jsx";
import Image from 'react-bootstrap/Image'

//Kachel 1 und Kachel2 muss description auch zusätzlich im file aktualisiert werden da unterschiedliches design desk und mobile
export const Kachel1 = {
    header: 'Yogakurse',
    subheaderA: 'Vinyasa Flow Yoga',
    subheaderB: 'Yin Yoga',
    image: OfferImg6,
    description: (
        <div>
            <strong className="mobileHighlighted">VINYASA FLOW YOGA </strong>
            ist eine Form des Hatha Yoga und basiert auf der Verbindung von Atem und Bewegung. Die Asanas (Körperhaltungen) werden fließend miteinander verbunden, der Atem initiiert die Bewegung. Durch die Vinyasa Praxis erhöhen wir den Energiefluss im System und sprechen die Muskulatur an. Es entsteht ein Flow, eine kraftvolle und zugleich entspannende Praxis. Zur Kräftigung werden manche Asanas länger gehalten.
            Anders als im Sport geht es darum, Körper und Geist in Einklang zu bringen und so ein Gefühl der Ausgeglichenheit und Entspannung zu erschaffen.
            <br/>
            <br/>
            <strong className="mobileHighlighted">YIN YOGA </strong>
            ist eine sanfte Yoga-Praxis, die tiefe Entspannung sowie Flexibilität fördert. Im Gegensatz zu dynamischen Yoga-Stilen werden beim Yin Yoga die Asanas (Körperhaltungen) passiv und ohne Muskelkraft für längere Zeit gehalten. Dadurch werden tiefere Gewebeschichten wie das Bindegewebe, die Faszien und die Gelenke angesprochen.
            Für das Wohlbefinden bringt Yin Yoga viele Vorteile: Die ruhigen, meditativen Haltungen helfen, Stress abzubauen und die Gedanken zu beruhigen. Körperlich unterstützt Yin Yoga die Mobilität und Flexibilität, was besonders hilfreich für Menschen mit sitzenden Tätigkeiten ist. Es stärkt zudem die Gelenke und verbessert die Durchblutung.
        </div>
    ),
    cardText1: (
        <Card.Text>
            Vinyasa Flow Yoga ist eine Form des Hatha Yoga und basiert auf der Verbindung von Atem und Bewegung.
            <br/>
            Die Asanas (Körperhaltungen) werden fließend miteinander verbunden, der Atem initiiert die Bewegung.
            <br/>
            Durch die Vinyasa Praxis erhöhen wir den Energiefluss im System und sprechen die Muskulatur an. Es entsteht ein Flow, eine kraftvolle und zugleich entspannende Praxis.
            <br/>
            Zur Kräftigung werden manche Asanas länger gehalten.
            <br/>
            Anders als im Sport geht es darum, Körper und Geist in Einklang zu bringen und so ein Gefühl der Ausgeglichenheit und Entspannung zu erschaffen.
        </Card.Text>
    ),
    cardText2: (
        <Card.Text>
            Yin Yoga ist eine sanfte Yoga-Praxis, die tiefe Entspannung sowie Flexibilität fördert.
            <br/>
            Im Gegensatz zu dynamischen Yoga-Stilen werden beim Yin Yoga die Asanas (Körperhaltungen) passiv und ohne Muskelkraft für längere Zeit gehalten. Dadurch werden tiefere Gewebeschichten wie das Bindegewebe, die Faszien und die Gelenke angesprochen.
            <br/>
            Für das Wohlbefinden bringt Yin Yoga viele Vorteile: Die ruhigen, meditativen Haltungen helfen, Stress abzubauen und die Gedanken zu beruhigen.
            <br/>
            Körperlich unterstützt Yin Yoga die Mobilität und Flexibilität, was besonders hilfreich für Menschen mit sitzenden Tätigkeiten ist. Es stärkt zudem die Gelenke und verbessert die Durchblutung.
        </Card.Text>
    )
};
export const Kachel2 = {
    header: 'Yoga in Landsberg am Lech',
    subheaderA: 'VHS Yogakurs',
    subheaderB: '',
    image: OfferImg5,
    description: (
        <div>
            <Card>
                <Card.Header>Freitags 15.30 -16.30 Uhr  im Yoga Loft Landsberg</Card.Header>
                <Card.Body>
                    <Card.Text>Yoga wo Du Dich wohlfühlst<br/>Du hast Lust auf Yoga?<br/>Vinyasa Flow Yoga<br/>
                        Wir üben kräftigend, fliessend, ausgleichend.<br/>
                        Auftanken und Wohlfühlen in kleiner Gruppe.<br/><br/>
                        Der Einstieg ist mit geringen Vorkenntnissen möglich. Sprich mich an wenn Du unsicher bist, ob es passt.<br/><br/>
                        Du benötigst nur bequeme Kleidung und Freude in einer kleinen Gruppe Yoga zu üben.
                        <br/><br/>
                        Monatliche Blockkarten ab 45,00 Euro je nach Terminzahl, Einzeltermin 18,00 Euro<br/><br/>
                        Probestunde 12,00 Euro, Anmeldung bis 24 Stunden vorher:&nbsp;
                        <a href="mailto:kontakt@sylkeheuer.de?subject=Anfrage PopUp Yoga">kontakt@sylkeheuer.de</a>
                        <br/>
                        <br/>
                        Bei weniger als 5 Anmeldungen kann ein Termin abgesagt werden.
                    </Card.Text>
                </Card.Body>
            </Card>
            <br/>
            <Card>
                <Card.Header>Yoga in der VHS Landsberg</Card.Header>
                <Card.Body>
                    {/* <Card.Title>Vinyasa Flow und Yin Yoga </Card.Title>
                                        <br></br>*/}

                    <Card.Text>Vinyasa Flow Yoga ohne oder wenig Vorkenntnisse <br/>
                        Wir aktivieren den Energiefluss im System und sprechen die Muskulatur an. Es entsteht ein Flow, eine kraftvolle und zugleich entspannende Praxis. Bitte mitbringen: ggf. eigene Matte, Decke
                        <br/><br/>
                        ab Do. 1.10.26, 19.15-20.30 Uhr, 10x
                        <br/><br/>
                        <a href="https://www.vhs-landsberg.de/kurse/gesundheit/yoga/kurs/Vinyasa-Flow-Yoga/E3522">zur Anmeldung</a>
                        <br/>
                        <br/>
                        Sanftes Yoga & Yin ohne oder wenig Vorkenntnisse<br/>
                        In dieser Stunde verbinden wir eine sanft fließende, aktivierende Yogapraxis mit wohltuenden Yin-Elementen. Gönn Dir diese Zeit für Dich – und spüre, wie Yoga Körper, Geist und Nervensystem in wohltuende Balance bringt. Bitte mitbringen: ggf. eigene Matte, Decke
                        <br/><br/>
                        ab Fr. 2.10.26, 9.00-10.15 Uhr, 10x
                        <br/><br/>
                        <a href="https://www.vhs-landsberg.de/kurse/gesundheit/bewegung-und-fitness/kurs/Sanftes-Yoga-Yin/E3523">zur Anmeldung</a>
                    </Card.Text>
                </Card.Body>
            </Card>
        </div>
    ),
};
export const Kachel3 = {
    header: 'Yoga Retreats',
    subheaderA: 'Deine Yogazeit an einem Wohlfühlort -Tanke auf',
    subheaderB: '',
    image: OfferImg4,
    accordionHeader1: '🧘‍♀️ Yogaretreat 17./18.April mit Ayurveda-Kochkurs 🌿 - WARTELISTE',
    accordionHeader2: '☀️ Yogaretreat im Allgäu 12.–14. Juni 2026 | Hotel Kaufmann bei Füssen 🌿',
    description1: (
        <div>
            <strong>Regeneration · Achtsamkeit · Genuss</strong>
            <br/><br/>
            Dieses Yogaretreat lädt dich ein, den Alltag hinter dir zu lassen und ganz bei dir anzukommen. Eine harmonische Verbindung aus Yoga, Naturerfahrung und ayurvedischer Küche schenkt dir neue Energie, innere Ruhe und wertvolle Impulse für dein Wohlbefinden.<br/><br/>
            In achtsamer Atmosphäre darfst du dich nähren – auf allen Ebenen.<br/><br/>
            <strong>Freitag – Ankommen & Entspannen</strong><br/>
            🕓 Start: 16:00 Uhr
            <ul>
                <li>Ayurveda-Kochkurs</li>
                <li>Gemeinsames Abendessen</li>
                <li>Yin Yoga zum sanften Ausklang</li>
            </ul>
            Der Freitag steht ganz im Zeichen des Ankommens, Loslassens und Einstimmens auf das Wochenende.<br/><br/>
            <strong>Samstag – Aktivieren & Regenerieren</strong>
            <ul>
                <li>Kräftigende & fliessende Yogastunde</li>
                <li>Ayurvedisches Frühstück</li>
                <li>Gehmeditation in der Natur</li>
                <li>Fliessende & regenerierende Yogastunde</li>
                <li>Gemeinsames Mittagessen</li>
            </ul>
            Ein ausgewogener Tag mit Bewegung, Natur und bewusster Ernährung – für neue Klarheit und Balance.<br/><br/>
            <strong>Abschluss</strong><br/>
            🕒 Ende des Retreats: 15:30 Uhr<br/><br/>
            Du gehst gestärkt, entspannt und inspiriert zurück in deinen Alltag.<br/><br/>

            <strong>Kosten</strong><br/><br/>
            Übernachtung
            <ul>
                <li>Einzelzimmer: 90 €</li>
                <li>Doppel-/Mehrbettzimmer: 70 €</li>
            </ul>
                Am ViehTheater Pauschale 135 €
            <ul>
                <li>Ayurveda-Kochkurs</li>
                <li>Ayurvedische Verpflegung</li>
                <li>Retreat-Getränke</li>
            </ul>
            Yogaeinheiten mit Sylke 120 €<br/><br/>
            <strong>Gesamtpreis: 335 - 355 €</strong><br/>
            (abhängig von der Zimmerwahl)<br/><br/>

            <strong>✨ Anmeldung</strong><br/>
            👉 Jetzt anmelden und deinen Platz sichern<br/>
            📧 Anmeldung&nbsp;
            <a href="mailto:kontakt@sylkeheuer.de?subject=Anfrage PopUp Yoga">kontakt@sylkeheuer.de</a><br/>
            📞 Fragen gerne unter: 0163 4437870<br/><br/>

            Ich freue mich darauf, dieses besondere Wochenende mit dir zu teilen!
        </div>
    ),
    description2: (
        <div>
            Dieses Yogawochenende lädt dich ein, bewusst aus dem Alltag auszusteigen und ganz bei dir anzukommen. Inmitten der beeindruckenden Allgäuer Bergwelt, nahe dem Forggensee, verbinden wir Yoga, Natur und Genuss zu einer tief nährenden Auszeit für Körper, Geist und Seele.<br/><br/>
            Das liebevoll geführte Vier-Sterne-Wellnesshotel Kaufmann bietet dafür den perfekten Rahmen: modernes alpines Design, ein großzügiger SPA-Bereich mit Poolhaus, traumhafte Ausblicke auf die Allgäuer Alpen und eine exzellente, regionale Küche – gerne vegetarisch oder vegan.<br/><br/>
            <strong>🧘‍♀️ Programm & Ablauf (Freitag–Sonntag)</strong><br/><br/>
            <strong>Freitag – Ankommen & Loslassen</strong><br/><br/>
            Ab 14:00 Uhr<br/>
            Anreise & Check-in – dein Zimmer steht für dich bereit.<br/>
            Zeit zum Ankommen, Durchatmen und ersten Entspannen im SPA.<br/><br/>

            17:30 – 18:45 Uhr<br/>
            Abendyoga<br/>
            Restoratives Yoga, sanfter Slow Flow – ideal, um die Woche hinter dir zu lassen und im Körper anzukommen.<br/><br/>

            19:00 Uhr<br/>
            Gemeinsames Abendessen<br/><br/>
            <strong>Samstag – Auftanken & Verbinden</strong><br/><br/>
            08:00 – 09:15 Uhr<br/>
            Morgenyoga<br/>
            Aktivierend und zentrierend – ein bewusster Start in den Tag.<br/><br/>

            Anschließend Frühstück<br/>
            Das reichhaltige Frühstücksbuffet steht uns bis ca. 10:15 Uhr zur Verfügung. Danach können wir entspannt sitzen bleiben – Kaffee und Getränke werden weiterhin serviert.
            <br/><br/>
            Ca. 11:00 – 12:30 Uhr<br/>
            Meditativer Spaziergang (optional)<br/>
            Gemeinsam gehen wir achtsam durch die Natur, lassen die Eindrücke wirken und vertiefen die Verbindung zu uns selbst.<br/><br/>

            Zeit zur freien Verfügung: SPA, Ruhe, Natur oder einfach Nichtstun.<br/><br/>

            17:30 – 18:45 Uhr<br/>
            Abendyoga<br/>
            Beruhigend, ausgleichend und regenerierend.<br/><br/>

            19:00 Uhr<br/>
            Gemeinsames Abendessen<br/><br/>


            <strong>Sonntag – Integration & Abschied</strong><br/><br/>
            08:00 – 09:15 Uhr<br/>
            Morgenyoga
            Klärend und verbindend – mit Raum zum Integrieren und Nachspüren.
            <br/><br/>
            Anschließend gemeinsames Frühstück.
            <br/><br/>
            Check-out bis Mittag<br/><br/>
            ✨ SPA-Nutzung auch nach dem Check-out kostenfrei möglich<br/><br/>

            <strong>✨ Spürst du den Ruf nach einer Pause?</strong><br/><br/>
            Dann lade ich dich von Herzen ein, dir dieses Wochenende zu schenken.<br/>
            Komm mit, atme auf, bewege dich, lass los – und nimm neue Energie mit nach Hause.
            <br/><br/>
            Ich freue mich sehr darauf, diese besondere Auszeit mit dir zu teilen. 🧘‍♀️💫<br/><br/>
            ✨ Inklusive:
            <ul>
                <li>2 Übernachtungen im Superior-Zimmer</li>
                <li>Verwöhn-Halbpension (auch vegetarisch/vegan)</li>
                <li>SPA-Nutzung – auch nach dem Check-out</li>
                <li>Yogaeinheiten und optionaler Spaziergang</li>
            </ul>
            🕊 Freitagabend bis Sonntagmittag<br/><br/>
            💶 Preis: 554 € (Einzelzimmer),<br/><br/>
            Du möchtest Deinen Partner oder eine andere Person mitbringen? Sprich mich gerne an.<br/><br/>
            <strong>📩 Anmeldung & Informationen:</strong><br/>
            <a href="mailto:kontakt@sylkeheuer.de?subject=Anfrage PopUp Yoga">kontakt@sylkeheuer.de</a><br/>
        </div>
    )
};
export const Kachel4 = {
    header: 'Firmenyoga & Mitarbeitergesundheit',
    header2: 'Firmenyoga & Mitarbeitergesundheit in Landsberg am Lech',
    subheaderA: 'Yoga regeneriert. Yoga schafft Raum für neue Ideen.',
    subheaderB: '',
    image: OfferImg1,
    description: (
        <div>
            <strong>
                Yoga regeneriert. Yoga schafft Raum für neue Ideen.
            </strong>
            <br/> <br/>
            Im getakteten Arbeitsalltag eine stärkende Pause machen, wieder „frei“ im Kopf werden und dabei dem Körper etwas Gutes tun?
            <br></br>
            <br></br>
            Ob überwiegend sitzende Tätigkeit oder körperlich fordernde Arbeit – berufliche Anforderungen können Körper und Geist auf unterschiedliche Weise beanspruchen.
            <br></br>
            <br></br>
            Yoga bietet einen Ausgleich durch Bewegung, bewusste Atmung und Regeneration. Die Yogastunden laden dazu ein, innezuhalten, neue Energie zu schöpfen und wieder bei sich anzukommen.
            <br></br>
            <br></br>
            Ich biete Yoga für Unternehmen, öffentliche Einrichtungen und soziale Organisationen in Landsberg am Lech und Umgebung an.
            <br></br>
            <br></br>
            <a href="mailto:kontakt@sylkeheuer.de?subject=Anfrage Firmenyoga">kontakt@sylkeheuer.de</a>
            <br></br>
            <br></br>
            <br/>

            <h5>Yoga für Ihre Mitarbeitenden</h5>
            Ob regelmäßiger Yogakurs oder kurze bewegte Pause – die Einheiten lassen sich an die Bedürfnisse Ihrer Mitarbeitenden und die Gegebenheiten vor Ort anpassen.
            <br></br>
            <br></br>
            Mögliche Formate sind:
            <br></br>
            <br></br>
            <ul>
                <li>regelmäßige Yogakurse in kleinen Gruppen</li>
                <li>kurze Yogaeinheiten als bewegte Pause</li>
                <li>individuell abgestimmte Yogaangebote</li>
            </ul>
            Die Übungen sind auch für Menschen ohne Yogaerfahrung geeignet und können an unterschiedliche körperliche Voraussetzungen angepasst werden.<br></br>
            <br></br>
            Gerne komme ich für die Yogastunden direkt zu Ihnen.
            <br></br>
            <br></br>
            <strong>Ein Angebot, das zu Ihnen passt</strong>
            <br></br>
            <br></br>
            Sie möchten Ihren Mitarbeitenden im Arbeitsalltag einen Raum für Bewegung, Regeneration und Entspannung bieten?
            <br></br>
            <br></br>
            Ich freue mich auf Ihre Anfrage. <a href="mailto:kontakt@sylkeheuer.de?subject=Anfrage Firmenyoga">kontakt@sylkeheuer.de</a>
        </div>
    )
};
export const Kachel5 = {
    header: 'Yoga Privatstunden',
    subheaderA: 'Personal Yoga, wo Du Dich wohl fühlst.',
    subheaderB: '',
    image: OfferImg2,
    description: (
        <div>
            <strong>Personal Yoga, wo Du Dich wohl fühlst.</strong>
            <br/> <br/>
            Ich biete individuelle Yogastunden, wo Du Dich wohl fühlst, wo Du auftanken und
            entspannen kannst. Yoga als ein Weg zu Dir und zu Deinem Körper - zugeschnitten auf Deine persönlichen Bedürfnisse.
            <br></br>
            <br></br>
            Fragst Du Dich ob Yoga überhaupt das Richtige für Dich ist?
            <br></br>
            <br></br>
            Du brauchst keine Vorkenntnisse haben oder besonders
            gelenkig sein. Wenn Du Yoga noch nicht ausprobiert hast,
            fangen wir zusammen an und schauen wie Dich Yoga
            unterstützen kann. Wenn Du schon Yoga praktizierst ganz
            genauso. Im Yoga findest Du das, was Du an diesem Tag, in
            diesem Moment brauchst.
            <br></br>
            <br></br>
            Die Stunden finden statt, wo Du Dich wohlfühlst, das kann
            Deine Wohnung, Dein Garten oder Dein Arbeitsplatz sein. Bei
            geeignetem Wetter gehen wir optional in die Natur - einen
            Park, eine Wiese, einen See oder einen Wald.
            <br></br>
            <br></br>
            Du möchtest mit eine:r Freund:in zusammen Yoga machen?
            <br></br>
            <br></br>
            Ich biete Yoga auch für zwei und mehr Personen an. Bitte
            kontaktiere mich und wir besprechen die Möglichkeiten.
            <br></br>
            <a href="mailto:kontakt@sylkeheuer.de?subject=Anfrage Privatyoga">kontakt@sylkeheuer.de</a>
        </div>
    )
};
export const Kachel6 = {
    header: 'Yoga in der Natur',
    subheaderA: 'Die Natur ist ein Wohlfühlort. Yoga in der Natur ist ideal zum regenerieren.',
    subheaderB: '',
    image: OfferImg3,
    description: (
        <div>
            Vögelzwitschern, Dein Blick in die schöne ursprüngliche Natur, die Luft spüren, Dich dehnen, bewegen. Energie aufnehmen, Ballast loslassen, regenerieren.
            <br/><br/>
            Deine Yogazeit in der Natur.
            <br/><br/>
            Yoga im Wildpark in Landsberg am Lech. Über Deinen Atem, bewußtes Gehen und Yoga verbindest Du Dich mit Deinem Körper und der Natur und regst Deine Sinne an.
            <br/>
            Du benötigst bequeme, wetterangepasste Kleidung und evtl. eine Matte.
            <br/>
            <br/>
            Termininfos <a href="mailto:kontakt@sylkeheuer.de?subject=Anfrage PopUp Yoga">kontakt@sylkeheuer.de</a>
            <br/>
            Energieausgleich 15,00 Euro
            <br/>
            <br/>
            Du möchtest ein One to One? Sprich mich gerne an.
        </div>
    )
};

function Offer() {
    const [matches, setMatches] = useState(window.innerWidth);

    window.addEventListener("resize", checkSize);

    function checkSize() {
        setMatches(window.innerWidth);
    }

    function onLinkClick() {
        document.getElementById("offer").scrollIntoView({behavior:"smooth", block: "center" });
    }
    return (
        <>
            <section className="offerSec" id="offer">
                {matches > 768 && (
                    <>
                        <h4 className="introHeader">{offerDescription[0].title}</h4>
                        {/*<div className="intro">{offerDescription[0].body}</div>*/}
                        <div className="intro">
                            Yoga ist ein 2000 Jahre altes ganzheitliches Übungssystem und weit mehr als nur eine körperliche Praxis. Das Wort Yoga (aus dem indischen Sanskrit) heißt soviel wie „Einheit“, „Verbindung“.
                            <br></br>
                            <br></br>
                            In unserer heutigen Welt kann Yoga Körper, Geist und Seele wieder in Verbindung bringen. In einem schnelllebigen und komplexen Alltag mit vielen Aufgaben und Ablenkungen entlastet Yoga Dich durch Ruhe und Klarheit.
                            <br></br>
                            <br></br>
                            Yoga bietet Dir körperlichen und mentalen Ausgleich zu oft einseitigen und überwiegend sitzenden Tätigkeiten am Bildschirm.
                            <br></br>
                            <br></br>
                            Ein bewußtes Rausnehmen mit Yoga aus Deinen Routinen begleitet Dich zurück zu Dir, Deinem Körper, Deinem Atem, dorthin, wo Du Dich wohlfühlen kannst.
                            <br></br><br></br>
                            Fragst Du Dich ob Yoga überhaupt das Richtige für Dich ist?
                            <br></br><br></br>
                            Du brauchst keine Vorkenntnisse haben oder besonders gelenkig sein. Yoga ist für jeden Körper und jedes Alter geeignet.",
                        </div>
                        <q>
                            Im Sinne, dass der Weg das Ziel ist, ist es mein Herzenswunsch Dich ein Stück auf Deinem Weg zu inspirieren.</q>

                        <h2 id="offerHeader">Angebot</h2>
                        <Row lg={3} className="g-4">
                            <Col>
                                <Card className="cardOfferHeight">
                                    <Card.Img className="cardImage" variant="top" src={Kachel1.image} id="imgYogakurse"/>
                                    <Card.Body className="offerBoxes">
                                        <Card.Title>{Kachel1.header}</Card.Title>
                                        <Card.Text>
                                                <strong>{Kachel1.subheaderA}</strong>
                                            <br></br>
                                            <strong>{Kachel1.subheaderB}</strong>
                                        </Card.Text>
                                        <LinkContainer to={`/yogakurse`}>
                                            <Button onClick={onLinkClick} className="btnDetails1">Details</Button>
                                        </LinkContainer>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card className="cardOfferHeight">
                                    <Card.Img className="cardImage" variant="top" src={Kachel2.image}/>
                                    <Card.Body className="offerBoxes">
                                        <Card.Title>{Kachel2.header}</Card.Title>
                                        <Card.Text>
                                            <strong>{Kachel2.subheaderA}</strong>
                                            <br></br>
                                            <strong>{Kachel2.subheaderB}</strong>
                                        </Card.Text>
                                        <LinkContainer to={`/yoga_Landsberg`}>
                                            <Button onClick={onLinkClick} className="btnDetails1">Details</Button>
                                        </LinkContainer>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card className="cardOfferHeight">
                                    <Card.Img className="cardImage" variant="top" src={Kachel3.image} id="imgYogaIsmaning"/>
                                    <Card.Body className="offerBoxes">
                                        <Card.Title>{Kachel3.header}</Card.Title>
                                        <Card.Text>
                                            <strong>{Kachel3.subheaderA}</strong>
                                            <br></br>
                                            <strong>{Kachel3.subheaderB}</strong>
                                        </Card.Text>
                                        <LinkContainer to={`/yoga_retreats`}>
                                            <Button onClick={onLinkClick} className="btnDetails1">Details</Button>
                                        </LinkContainer>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                            <Card className="cardOfferHeight">
                                <Card.Img className="cardImage" variant="top" src={Kachel4.image} id="imgFirmenYoga"/>
                                <Card.Body className="offerBoxes">
                                    <Card.Title>{Kachel4.header}</Card.Title>
                                    <br></br>
                                    <Card.Text>
                                        <strong>{Kachel4.subheaderA}</strong>
                                        <br></br>
                                        <strong>{Kachel4.subheaderB}</strong>
                                    </Card.Text>
                                    <LinkContainer to={`/Firmenyoga`}>
                                        <Button onClick={onLinkClick} className="btnDetails2">Details</Button>
                                    </LinkContainer>
                                </Card.Body>
                            </Card>
                            </Col>
                            <Col>
                                <Card className="cardOfferHeight">
                                    <Card.Img className="cardImage" variant="top" src={Kachel5.image}/>
                                    <Card.Body className="offerBoxes">
                                        <Card.Title>{Kachel5.header}</Card.Title>
                                        <br></br>
                                        <Card.Text className="paddingBottom24">
                                            <strong>{Kachel5.subheaderA}</strong>
                                            <br></br>
                                            <strong>{Kachel5.subheaderB}</strong>
                                        </Card.Text>
                                        <LinkContainer to={`/Privatstunden`}>
                                            <Button onClick={onLinkClick} className="btnDetails1">Details</Button>
                                        </LinkContainer>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card className="cardOfferHeight">
                                    <Card.Img className="cardImage" variant="top"  src={Kachel6.image} id="imgYogaNatur"/>
                                    <Card.Body className="offerBoxes">
                                        <Card.Title>{Kachel6.header}</Card.Title>
                                        <br></br>
                                        <Card.Text>
                                            <strong>{Kachel6.subheaderA}</strong>
                                            <br></br>
                                            <strong>{Kachel6.subheaderB}</strong>
                                        </Card.Text>
                                        <LinkContainer to={`/Yoga_in_der_Natur`}>
                                            <Button onClick={onLinkClick}>Details</Button>
                                        </LinkContainer>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </>
                )}
                {matches < 768 && (
                    <>
                        <h4 className="introHeader">Yoga, wo Du Dich wohlfühlst – in Landsberg am Lech</h4>
                        <div className="intro">
                            <p>Yoga ist ein 2000 Jahre altes ganzheitliches Übungssystem und weit mehr als nur eine
                                körperliche Praxis. Das Wort Yoga (aus dem indischen Sanskrit) heißt soviel wie
                                „Einheit“, „Verbindung“.</p>
                            <p>
                                In unserer heutigen Welt kann Yoga Körper, Geist und Seele wieder in Verbindung bringen.
                                In einem schnelllebigen und komplexen Alltag mit vielen Aufgaben und Ablenkungen
                                entlastet Yoga Dich durch Ruhe und Klarheit.
                            </p>
                            <p>
                                Yoga bietet Dir körperlichen und mentalen Ausgleich zu oft einseitigen und überwiegend
                                sitzenden Tätigkeiten am Bildschirm.
                            </p>
                            <p>
                                Ein bewußtes Rausnehmen mit Yoga aus Deinen Routinen begleitet Dich zurück zu Dir,
                                Deinem Körper, Deinem Atem, dorthin, wo Du Dich wohlfühlen kannst.
                            </p>
                            <p>
                                Fragst Du Dich ob Yoga überhaupt das Richtige für Dich ist?
                            </p>
                            <p>
                                Du brauchst keine Vorkenntnisse haben oder besonders gelenkig sein. Yoga ist für jeden
                                Körper und jedes Alter geeignet.
                            </p>
                            <q>
                                Im Sinne, das der Weg das Ziel ist, ist es mein Herzenswunsch Dich ein Stück auf Deinem Weg zu inspirieren.</q>
                        </div>
                        <h2 id="offerHeader">Angebot</h2>
                        <Image className="offerMobile" src={OfferImg4}></Image>

                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>{Kachel1.header}</Accordion.Header>
                                <Accordion.Body>
                                    {Kachel1.description}
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>{Kachel2.header}</Accordion.Header>
                                <Accordion.Body>
                                    {Kachel2.description}
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>{Kachel3.accordionHeader1}</Accordion.Header>
                                <Accordion.Body>
                                    {Kachel3.description1}
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>{Kachel3.accordionHeader2}</Accordion.Header>
                                <Accordion.Body>
                                    {Kachel3.description2}
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>{Kachel4.header2}</Accordion.Header>
                                <Accordion.Body>
                                    {Kachel4.description}
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>{Kachel5.header}</Accordion.Header>
                                <Accordion.Body>
                                    {Kachel5.description}
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>{Kachel6.header}</Accordion.Header>
                                <Accordion.Body>
                                    {Kachel6.description}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </>
                )}
            </section>
        </>
    );
}

export default function OfferRoutes() {
    return (

        <Routes>
            <Route index element={<Offer/>}/>
            <Route path="Yogakurse" element={<Yogakurse/>}/>
            <Route path="Privatstunden" element={<Privatstunden/>}/>
            <Route path="Firmenyoga" element={<Firmenyoga/>}/>
            <Route path="Yoga_in_der_Natur" element={<YogaNatur/>}/>
            <Route path="Yoga_Retreats" element={<Retreats/>}/>
            <Route path="Yoga_Landsberg" element={<Landsberg/>}/>
            {/*<Route path="Popup" element={<Popup/>}/>*/}
        </Routes>
    );
}
